import { Navigate, Route, Routes } from 'react-router';
import { ApiClientProvider } from '../Contexts/ApiClient.Context';
import { GenerateProvider } from '../Contexts/Generate.Context';
import { Home } from '../Pages/Home.page';
import { Sidebar } from './Sidebar/Sidebar';
import { Main } from './Main';
import { Content } from './Content';
import { LocationsProvider } from '../Contexts/Locations.Context';
import { LocationsPage } from '../Pages/Locations/Locations.page';
import { GroceriesProvider } from '../Contexts/Groceries.Context';
import { RemindersProvider } from '../Contexts/Reminders.Context';
import { GroceriesPage } from '../Pages/Groceries/Groceries.page';
import { MoviesPage } from '../Pages/Movies/Movies.page';
import { RemindersPage } from '../Pages/Reminders/Reminders.page';
import { MoviesProvider } from '../Contexts/Movies.Context';
import { ExerciseTypesProvider } from '../Contexts/ExerciseTypes.Context';
import { ExerciseLogsProvider } from '../Contexts/ExerciseLogs.Context';
import { SettingsPage } from '../Pages/Settings/Settings.page';
import { ExerciseLogsPage } from '../Pages/ExerciseLogs/ExerciseLogs.page';

export const AuthLayout = () => {
  return (
    <ApiClientProvider>
      <GenerateProvider>
        <LocationsProvider>
          <GroceriesProvider>
            <RemindersProvider>
              <MoviesProvider>
                <ExerciseTypesProvider>
                  <ExerciseLogsProvider>
                    <Main>
                      <Sidebar />
                      <Content>
                        <Routes>
                          <Route path="/home" element={<Home />} />
                          <Route path="/" element={<Navigate to="/home" replace />} />
                          <Route path="locations" element={<LocationsPage />} />
                          <Route path="groceries" element={<GroceriesPage />} />
                          <Route path="movies" element={<MoviesPage />} />
                          <Route path="reminders" element={<RemindersPage />} />
                          <Route path="exercises" element={<ExerciseLogsPage />} />
                          <Route path="settings" element={<SettingsPage />} />
                        </Routes>
                      </Content>
                    </Main>
                  </ExerciseLogsProvider>
                </ExerciseTypesProvider>
              </MoviesProvider>
            </RemindersProvider>
          </GroceriesProvider>
        </LocationsProvider>
      </GenerateProvider>
    </ApiClientProvider>
  );
};
